import Toggle from '../../../../components/Toggle';
import { STable, RightAlignedCell, SpacedText } from './style';

const Table = ({ columns, data, selectedFiles, onSelectFile, onSelectAll, onClickFile }) => {
  return (
    <STable>
      <thead>
        <tr>
          {columns.map((column, c) => (
            <td key={c}>{column.name}</td>
          ))}
          <RightAlignedCell>
            <Toggle isChecked={selectedFiles.length === data.length} onToggle={onSelectAll} />{' '}
            <SpacedText>Select All</SpacedText>
          </RightAlignedCell>
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr key={i}>
            {columns.map((column, c) => (
              <td key={c} onClick={c === 0 ? () => onClickFile(item) : () => {}}>
                {column.render ? column.render(item) : item[column.key]}
              </td>
            ))}
            <RightAlignedCell>
              <Toggle
                isChecked={!!selectedFiles.find(file => file.name === item.name)}
                onToggle={() => onSelectFile(item)}
              />
            </RightAlignedCell>
          </tr>
        ))}
      </tbody>
    </STable>
  );
};

export default Table;
